import { Directive } from '@angular/core';

@Directive({
  selector: '[egFieldPrefixDirective]',
  standalone: false,
})
export class FieldPrefixDirective {}
